import React from "react";
import PeopleHappyImage from "../assets/images/illustrations/people_happy.png";
import NurtureLogo from "../assets/images/logo.png";
var AssignmentError = function AssignmentError(_ref) {
  var errorMessage = _ref.errorMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger",
    role: "alert"
  }, errorMessage)), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("img", {
    src: NurtureLogo,
    alt: "Nurture",
    className: "my-3 nurture-logo"
  }), /*#__PURE__*/React.createElement("img", {
    src: PeopleHappyImage,
    alt: "People Happy",
    className: "img-fluid"
  }))))));
};
AssignmentError.defaultProps = {
  errorMessage: 'Something went wrong! please check your internet and try again.'
};
export default AssignmentError;